<template>
  <div id="counselors">
    <div v-for="counselor in list_counselors">
      <div class="counselor row">
        <div class='counselor-image'>
          <div class="avatar-counselor">
            <a :href="'/counselor?id='+counselor.id">
              <img v-if="counselor.avatar == ''" src="../../../assets/images/counselor/candidate.png">
              <img v-else class="avatar-photo" :src="counselor.avatar">
            </a>                        
          </div>
          <div class="name-counselor">{{counselor.name}}</div>
        </div>
        <div class="counselor-about">
          <div class="job-information element-info">
            <i class="fa fa-user"></i>
            Nghề nghiệp: {{counselor.counselor_title}}
          </div>
          <div class="degree-information element-info">
            <i class="fa fa-bookmark"></i>
            Bằng cấp: {{counselor.degree[0].major}}
          </div>
          <div class="uni-information element-info">
            <i class="fa fa-graduation-cap"></i>
            Trường: {{counselor.degree[0].university}}
          </div>
          <div class="address-information element-info">
            <i class="fa fa-map-marker"></i>
            Nơi đang sinh sống: {{counselor.address}}
          </div>
          <div class="button_element">
            <a class="btn button color_button" :href="'/counselor?id='+counselor.id">
            <i class="fa fa-arrow-right"></i></a>
          </div>          
        </div>        
      </div>
    </div>
   
    <base-pagination      
      :pageCount="pagination.total_page"
      :value="pagination.current_page"
      @input="pagination.current_page = $event"
    ></base-pagination>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  export default{
    computed: {
      ...mapState('vuex_network_counselors',{
        list_counselors: state => state.list_counselors,
        total_page: state => state.pagination.total_page,
        current_page: state => state.pagination.current_page,
        pagination: state => {
          return state.pagination
        },
        status_search: state => state.status_search,
        keyword: state => state.keyword
      }),
      ...mapState('user', {
        user: state => state.user
      }),
    },
    watch:{
      current_page(new_value, old_value){
        if (old_value != undefined){
          this.$store.dispatch('vuex_network_counselors/load_list_counselors', {page: new_value, keyword: this.keyword})
        }
      },
    },
    created: function(){
    },
    methods: {
      // load_list_counselors_with_page_num(page_num){
      //   this.$store.dispatch('vuex_network_counselors/load_list_counselors',page_num)
      // }
    }
    

  };
</script>
<style lang="scss" scoped>
  @import './counselors';
</style>


// WEBPACK FOOTER //
// src/views/components/NetworkCounselor/Counselors.vue